import { C as Cart } from './cart-BCBag437.js';
import { P as Pubsub } from './pubsub-DKqIEqaC.js';
import './notyf-DIw0RvBj.js';

class CartDrawerSummary extends HTMLElement {
  unsubscribers = [];
  buttons = this.querySelectorAll('.button');

  static {
    Cart.sections.push('fetch-cart-drawer-summary');
  }

  connectedCallback() {
    ['cart:add', 'cart:update', 'cart:change'].forEach((event) =>
      this.unsubscribers.push(
        Pubsub.subscribe(event, ({ sections }) => this.renderSection(sections))
      )
    );

    this.unsubscribers.push(Pubsub.subscribe('cart:fetching', () => this.handleLoading(true)));
    ['cart:fetched', 'cart:error'].forEach((event) =>
      this.unsubscribers.push(Pubsub.subscribe(event, () => this.handleLoading(false)))
    );
  }

  disconnectedCallback() {
    this.unsubscribers.forEach((unsubscribe) => unsubscribe());
  }

  renderSection(sections) {
    const html = new DOMParser().parseFromString(
      sections['fetch-cart-drawer-summary'],
      'text/html'
    );
    const target = html.querySelector('cart-drawer-summary');
    this.replaceWith(target);
  }

  handleLoading(loading) {
    this.buttons.forEach((button) => {
      button.classList.toggle('loading', loading);
    });
  }
}

customElements.define('cart-drawer-summary', CartDrawerSummary);
